function setupLogoUploadPreview() {
  $('.logo-upload-input').off('change.logoPreview').on('change.logoPreview', (event) => {
    const input = event.currentTarget;
    const previewContainer = $(input).siblings('div').first();
    const previewImage = previewContainer.find('.logo-upload-preview');

    if (input.logoPreviewUrl) {
      URL.revokeObjectURL(input.logoPreviewUrl);
      input.logoPreviewUrl = null;
    }

    if (!input.files || input.files.length === 0) {
      previewContainer.addClass('d-none');
      previewImage.attr('src', '');
      return;
    }

    input.logoPreviewUrl = URL.createObjectURL(input.files[0]);
    previewImage.attr('src', input.logoPreviewUrl);
    previewContainer.removeClass('d-none');
  });
}

$(document).on('turbo:load', () => {
  if ($('.logo-upload-input').length === 0) return;

  setupLogoUploadPreview();
});